import React from "react";
import PinStatusPicker from "../../common/PinStatusPicker";
import { propertyDetailsPath } from "../../../helpers/propertyDetailsLink";

/** What a click on a job tracker pin shows: the property, its status, and a way in. */
export default function PinPopupContent({ pin }) {
  return (
    <div style={{ padding: 10, minWidth: 240, maxWidth: 300 }} data-testid="pin-popup">
      <div>Full Address:</div>
      <p style={styles.info}>{pin.address || "Address not available"}</p>

      <PinStatusPicker propertyId={pin.property_id} compact />

      <div style={styles.linkContainer}>
        <a
          style={styles.link}
          href={propertyDetailsPath(pin.property_id)}
        >
          Property Details
        </a>
      </div>
    </div>
  );
}

// Matches the parcel popup (Popup.jsx) so both read as one design.
const styles = {
  info: {
    fontWeight: 500,
    fontSize: 14,
    color: "#000",
    opacity: 0.65,
    margin: 0,
  },
  link: {
    fontWeight: 500,
    fontSize: 15,
    color: "white",
    textDecoration: "none",
  },
  linkContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#67773f",
    width: "100%",
    padding: 10,
    marginTop: 10,
    color: "white",
  },
};
